"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var VideoPlayerControls_1 = __importDefault(require("./VideoPlayerControls"));
var VideoPlayerViewGrid_1 = __importDefault(require("./VideoPlayerViewGrid"));
var VideoPlayerViewGallery_1 = __importDefault(require("./VideoPlayerViewGallery"));
var LineGraph_1 = __importDefault(require("../Graph/LineGraph"));
var videoPlayer_1 = require("../../utils/videoPlayer");
var VideoPlayerOverlay_1 = __importDefault(require("./VideoPlayerOverlay"));
var VideoPlayer = (0, react_1.forwardRef)(function (_a, ref) {
    var _b;
    var sources = _a.sources, labels = _a.labels, className = _a.className, disabled = _a.disabled, _c = _a.allowDownload, allowDownload = _c === void 0 ? true : _c, children = _a.children, lineGraphProps = _a.lineGraphProps, defaultView = _a.defaultView;
    var videoRef = react_1.default.useRef(null);
    var videoListener = react_1.default.useRef((0, videoPlayer_1.buildVideoPlayerListener)());
    var _d = __read(react_1.default.useState({
        playing: false,
        error: false,
        currentTime: 0,
        duration: 0,
        volume: 0.8,
        fullscreen: false,
        view: sources.length > 1 ? (defaultView || "gallery") : "grid",
    }), 2), playback = _d[0], setPlayback = _d[1];
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d, _e;
        var timeUpdateHandler = function () {
            setPlayback(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), { currentTime: ((_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.currentTime) || 0 }));
            });
        };
        var durationChangeHandler = function () {
            setPlayback(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), { duration: ((_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.duration) || 0 }));
            });
        };
        var endedHandler = function () {
            setTimeout(function () {
                var _a;
                (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.pause();
            }, 1000);
        };
        var errorHandler = function () {
            setPlayback(function (prevState) { return (__assign(__assign({}, prevState), { error: true })); });
        };
        var loadStartHandler = function () {
            setPlayback(function (prevState) { return (__assign(__assign({}, prevState), { error: false })); });
        };
        (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener("timeupdate", timeUpdateHandler);
        (_b = videoRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener("durationchange", durationChangeHandler);
        (_c = videoRef.current) === null || _c === void 0 ? void 0 : _c.addEventListener("ended", endedHandler);
        (_d = videoRef.current) === null || _d === void 0 ? void 0 : _d.addEventListener("error", errorHandler);
        (_e = videoRef.current) === null || _e === void 0 ? void 0 : _e.addEventListener("loadstart", loadStartHandler);
        return function () {
            var _a, _b, _c, _d, _e;
            (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener("timeupdate", timeUpdateHandler);
            (_b = videoRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener("durationchange", durationChangeHandler);
            (_c = videoRef.current) === null || _c === void 0 ? void 0 : _c.removeEventListener("ended", endedHandler);
            (_d = videoRef.current) === null || _d === void 0 ? void 0 : _d.removeEventListener("error", errorHandler);
            (_e = videoRef.current) === null || _e === void 0 ? void 0 : _e.removeEventListener("loadstart", loadStartHandler);
        };
    }, []);
    (0, react_1.useEffect)(function () {
        if (videoRef.current) {
            videoRef.current.volume = playback.volume;
        }
    }, [playback.volume]);
    var canPlay = !disabled && playback.duration && !playback.error;
    var playVideo = function () {
        var _a;
        setPlayback(function (prevState) { return (__assign(__assign({}, prevState), { playing: true })); });
        (_a = videoListener.current) === null || _a === void 0 ? void 0 : _a.trigger("play", null);
    };
    var pauseVideo = function () {
        var _a;
        setPlayback(function (prevState) { return (__assign(__assign({}, prevState), { playing: false })); });
        (_a = videoListener.current) === null || _a === void 0 ? void 0 : _a.trigger("pause", null);
    };
    var getVideoElement = function (playback) {
        var overlay = (react_1.default.createElement(VideoPlayerOverlay_1.default, { playing: playback.playing, error: playback.error, onClick: canPlay ? function () {
                if (playback.playing) {
                    pauseVideo();
                }
                else {
                    playVideo();
                }
            } : undefined }));
        if (!sources.length) {
            return null;
        }
        if (playback.error) {
            return overlay;
        }
        if (playback.view === "gallery") {
            return (react_1.default.createElement(VideoPlayerViewGallery_1.default, { sources: sources, labels: labels, videoListener: videoListener.current, mainVideoRef: videoRef, overlay: overlay }, children));
        }
        return (react_1.default.createElement(VideoPlayerViewGrid_1.default, { sources: sources, labels: labels, videoListener: videoListener.current, mainVideoRef: videoRef, overlay: overlay }, children));
    };
    var handleDownload = function () {
        if (sources.length) {
            var url = sources[0];
            if (url) {
                var a = document.createElement("a");
                a.href = url;
                a.download = "video.mp4";
                a.click();
            }
        }
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-video-player", !canPlay && "disabled", playback.fullscreen && "ui-video-player-fullscreen", className), ref: ref },
        getVideoElement(playback),
        react_1.default.createElement(VideoPlayerControls_1.default, { onPlay: playVideo, onPause: pauseVideo, onSeek: function (percentage) {
                var _a;
                setPlayback(function (prevState) {
                    return __assign(__assign({}, prevState), { currentTime: prevState.duration * percentage });
                });
                (_a = videoListener.current) === null || _a === void 0 ? void 0 : _a.trigger("seek", playback.duration * percentage);
            }, onVolumeChange: function (value) {
                setPlayback(function (prevState) { return (__assign(__assign({}, prevState), { volume: value })); });
            }, onViewChange: function (view) {
                setPlayback(function (prevState) { return (__assign(__assign({}, prevState), { view: prevState.view === "gallery" ? "grid" : "gallery" })); });
            }, onFullScreenToggle: function () {
                setPlayback(function (prevState) { return (__assign(__assign({}, prevState), { fullscreen: !prevState.fullscreen })); });
            }, onDownload: handleDownload, showViewButton: sources.length > 1, playback: playback, disabled: !canPlay, allowDownload: allowDownload }),
        lineGraphProps && ((_b = lineGraphProps.dataSets) === null || _b === void 0 ? void 0 : _b.length) ? (react_1.default.createElement(LineGraph_1.default, __assign({}, lineGraphProps, { aspectRatio: 3 }))) : null));
});
exports.default = VideoPlayer;
